// Getters
export const operations = (state) => {
  return state.operations.data || []
}
export const operationsLoading = (state) => {
  return state.operations.loading
}
export const operationsLastUpdate = (state) => {
  return state.operations.lastUpdate
}

export const clients = (state) => {
  return state.clients.data || []
}
export const clientsLoading = (state) => {
  return state.clients.loading
}
export const clientsLastUpdate = (state) => {
  return state.clients.lastUpdate
}

export const clientAssets = (state) => {
  return state.clientAssets.data || []
}
export const clientAssetsLoading = (state) => {
  return state.clientAssets.loading
}
export const clientAssetsLastUpdate = (state) => {
  return state.clientAssets.lastUpdate
}

export const assets = (state) => {
  return state.assets.data || []
}
export const assetsMetadata = (state) => {
  return state.assets.metadata || {}
}
export const assetsLoading = (state) => {
  return state.assets.loading
}
export const assetsLastUpdate = (state) => {
  return state.assets.lastUpdate
}

export const clientAccount = (state) => {
  return state.clientAccount.data || []
}
export const clientAccountLoading = (state) => {
  return state.clientAccount.loading
}
export const clientAccountLastUpdate = (state) => {
  return state.clientAccount.lastUpdate
}

export const clientExtract = (state) => {
  return state.clientExtract.data || []
}
export const clientExtractMetadata = (state) => {
  return state.clientExtract.metadata || {}
}
export const clientExtractLoading = (state) => {
  return state.clientExtract.loading
}
export const clientExtractLastUpdate = (state) => {
  return state.clientExtract.lastUpdate
}

export const tranches = (state) => {
  return state.tranches.data || []
}
export const tranchesLoading = (state) => {
  return state.tranches.loading
}
export const tranchesLastUpdate = (state) => {
  return state.tranches.lastUpdate
}


export const cashback = (state) => {
  return state.cashback.data || []
}
export const cashbackLoading = (state) => {
  return state.cashback.loading
}
export const cashbackLastUpdate = (state) => {
  return state.cashback.lastUpdate
}

export const solicitacoes = (state) => {
  return state.solicitacoes.data || []
}
export const solicitacoesLoading = (state) => {
  return state.solicitacoes.loading
}
export const solicitacoesLastUpdate = (state) => {
  return state.solicitacoes.lastUpdate
}
const SOLICITACOES_CATALOGO_DEFAULT = { areas: [], tipos: [] }
export const solicitacoesCatalogo = (state) => {
  return (state.solicitacoes && state.solicitacoes.catalogo) || SOLICITACOES_CATALOGO_DEFAULT
}

